import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MetadataService } from '../../../shared/services/metadata.service';
import { Observable, tap } from 'rxjs';
import { System } from '../../../shared/types/system';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
    selector: 'las-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    standalone: false,
})
export class BannerComponent {
    private initialStatus = '';

    quillStyle = {
        borderRadius: '5px',
        background: 'white',
    };

    form: FormGroup;
    isAdmin = false;
    isEditing = false;
    isReadOnly = true;
    status$: Observable<System>;

    // TODO: Customize the toolbar if need be; for now, it's the default.
    // modules: QuillModules = {};

    constructor(
        private metadataService: MetadataService,
        private auth: AuthService,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.formBuilder.group({
            status: [''],
        });

        this.isAdmin = auth.isAdmin();

        // We observe the status from the service which will emit the current
        // status and all updated statuses.
        this.status$ = this.metadataService.status$.pipe(
            tap((system) => {
                system.status ??= '';
                this.form.setValue(system);
                this.initialStatus = system.status;
                this.isEditing = false;
            }),
        );
    }

    submit() {
        if (this.hasChanges()) {
            const status = this.getStatus();
            this.metadataService.saveSystemStatus(status?.value);
        } else {
            // TODO: Snackbar about no changes saved and close?
        }
    }

    toggleEdit() {
        this.isEditing = !this.isEditing;
        if (!this.isEditing) {
            if (this.hasChanges()) {
                // TODO: Warn them with a snackbar/modal/confirm?
                // The current system alerts them but does nothing with the response.
                // (i.e., it closes the edit even if I cancel)
                alert("You've got changes!");
                this.resetStatus();
            }
        }
    }

    private getStatus = () => this.form.get('status');

    private resetStatus = () => this.getStatus()?.setValue(this.initialStatus);

    // TODO: Trim [start | end | both] before checking?
    private hasChanges = (): boolean =>
        this.getStatus()?.value !== this.initialStatus;
}
